import { vfTypesEnum, socket_types } from './enums';

export const spaModeOptions = [
  { value: 0, label: 'Pool Mode' },
  { value: 1, label: 'Spa Mode' },
];

export const offOnOptions = [
  { value: 0, label: 'Off' },
  { value: 1, label: 'On' },
];

export const heaterOffOnOptions = [
  { value: 0, label: 'Off' },
  { value: 1, label: 'On' },
  { value: 2, label: 'Pool & Spa' },
  { value: 3, label: 'Pool' },
  { value: 4, label: 'Spa' },
];

export const DisableEnableOptions = [
  { value: 0, label: 'Disabled' },
  { value: 1, label: 'Enabled' },
];

export const ReverseDisableEnableOptions = [
  { value: 0, label: 'Enabled' },
  { value: 1, label: 'Disabled' },
];

export const loggingRemoteDisableEnableOptions = [
  { value: 0xad, label: 'Disabled' },
  { value: 0xba, label: 'Enabled' },
];

export const offOnAutoOptions = [
  { value: 0, label: 'Off' },
  { value: 1, label: 'On' },
  { value: 2, label: 'Auto' },
];

export const ControlPumpSpeedOptions = [
  { value: 0, label: 'Off' },
  { value: 0x0101, label: '1' },
  { value: 0x0201, label: '2' },
  { value: 0x0301, label: '3' },
  { value: 0x0401, label: '4' },
  { value: 0xffff, label: 'Auto' },
];

export const PumpSpeedOptions = [
  { value: 0, label: '1' },
  { value: 1, label: '2' },
  { value: 2, label: '3' },
  { value: 3, label: '4' },
];

export const offAutoOptions = [
  { value: 0, label: 'Off' },
  { value: 2, label: 'Auto' },
];

export const spaBlowerTimeOutOptions = [
  { value: 0, label: 'Off' },
  { value: 1, label: '30 Mins' },
  { value: 2, label: '1 Hr' },
  { value: 3, label: '2 Hrs' },
];

export const thermistorTypeOptions = [
  { value: 0, label: 'None' },
  { value: 1, label: 'Pool' },
  { value: 2, label: 'Roof' },
  { value: 3, label: 'Water' },
];

export const solarSensorLocations = [
  { value: 0, label: 'Filter Line' },
  { value: 1, label: 'Heater Line' },
];

export const solarTypeOptions = [
  { value: 0, label: 'None' },
  { value: 1, label: 'Separate' },
  { value: 2, label: 'Valve' },
  { value: 3, label: 'Boosted' },
];

export const heatingPumpTypes = [
  { value: 0, label: 'Filter' },
  { value: 1, label: 'Independent' },
  { value: 2, label: 'Independent with Sensor' },
];

export const spaSizeOptions = [
  { value: 0, label: 'None' },
  { value: 1, label: '1000' },
  { value: 2, label: '1500' },
  { value: 3, label: '2000' },
  { value: 4, label: '2500' },
  { value: 5, label: '3000' },
  { value: 6, label: '4000' },
  { value: 7, label: '5000' },
  { value: 8, label: '6000' },
  { value: 9, label: '7000' },
  { value: 10, label: '8000' },
  { value: 11, label: '9000' },
];

export const poolSizeOptions = [
  { value: 0, label: 'None' },
  { value: 1, label: '10000' },
  { value: 2, label: '15000' },
  { value: 3, label: '20000' },
  { value: 4, label: '25000' },
  { value: 5, label: '30000' },
  { value: 6, label: '35000' },
  { value: 7, label: '40000' },
  { value: 8, label: '45000' },
  { value: 9, label: '50000' },
  { value: 10, label: '55000' },
  { value: 11, label: '60000' },
  { value: 12, label: '65000' },
  { value: 13, label: '70000' },
  { value: 14, label: '75000' },
  { value: 15, label: '80000' },
  { value: 16, label: '85000' },
  { value: 17, label: '90000' },
  { value: 18, label: '95000' },
  { value: 19, label: '100000' },
];

export const logIntervalOptions = [
  { value: 0, label: 'Off' },
  { value: 1, label: '1 Min' },
  { value: 5, label: '5 Mins' },
  { value: 10, label: '10 Mins' },
  { value: 15, label: '15 Mins' },
  { value: 30, label: '30 Mins' },
  { value: 60, label: '1 Hour' },
];

export const logDisableOptions = [
  { value: 0, label: 'All Enabled' },
  { value: 1, label: 'Status Disabled' },
  { value: 2, label: 'Config Disabled' },
  { value: 4, label: 'Data Disabled' },
  { value: 8, label: 'Fault Disabled' },
];

export const startTimeOptions = [
  { value: 0x0000, label: '00:00' },
  { value: 0x0100, label: '01:00' },
  { value: 0x0200, label: '02:00' },
  { value: 0x0300, label: '03:00' },
  { value: 0x0400, label: '04:00' },
  { value: 0x0500, label: '05:00' },
  { value: 0x0600, label: '06:00' },
  { value: 0x0700, label: '07:00' },
  { value: 0x0800, label: '08:00' },
  { value: 0x0900, label: '09:00' },
  { value: 0x0a00, label: '10:00' },
  { value: 0x0b00, label: '11:00' },
  { value: 0x0c00, label: '12:00' },
  { value: 0x0d00, label: '13:00' },
  { value: 0x0e00, label: '14:00' },
  { value: 0x0f00, label: '15:00' },
  { value: 0x1000, label: '16:00' },
  { value: 0x1100, label: '17:00' },
  { value: 0x1200, label: '18:00' },
  { value: 0x1300, label: '19:00' },
  { value: 0x1400, label: '20:00' },
  { value: 0x1500, label: '21:00' },
  { value: 0x1600, label: '22:00' },
  { value: 0x1700, label: '23:00' },
];

export const VFTypesSelect = [
  { value: vfTypesEnum.NONE, label: 'None' },
  { value: vfTypesEnum.GAS_HEATER, label: 'Gas Heater' },
  { value: vfTypesEnum.HEAT_PUMP, label: 'Heat Pump' },
  { value: vfTypesEnum.SMART_HEATER, label: 'Smart Heater' },
];

export const VFTypesSelect_no_smart = [
  { value: vfTypesEnum.NONE, label: 'None' },
  { value: vfTypesEnum.GAS_HEATER, label: 'Gas Heater' },
  { value: vfTypesEnum.HEAT_PUMP, label: 'Heat Pump' },
];

export const ValveTypesSelect = [
  { value: 0, label: 'None' },
  { value: 1, label: 'Pool/Spa' },
  { value: 2, label: 'Solar' },
  { value: 3, label: 'Water Feature' },
  { value: 4, label: 'In Floor' },
  { value: 5, label: 'Feature From Solar' },
  { value: 6, label: 'Other' },
  { value: 7, label: 'Heating' },
];

export const SocketTypesSelect = [
  { value: socket_types.NONE, label: 'None' },
  { value: socket_types.SANITISER, label: 'Sanitiser' },
  { value: socket_types.FILTER_PUMP, label: 'Filter Pump' },
  { value: socket_types.CLEAN_PUMP, label: 'Cleaning Pump' },
  { value: socket_types.BLOWER, label: 'Blower' },
  { value: socket_types.POOL_LIGHT, label: 'Pool Light' },
  { value: socket_types.SPA_LIGHT, label: 'Spa Light' },
  { value: socket_types.GARDEN_LIGHT, label: 'Garden Light' },
  { value: socket_types.WATER_FEATURE, label: 'Water Feature' },
  { value: socket_types.SOLAR, label: 'Solar' },
  { value: socket_types.OTHER, label: 'Other' },
  { value: socket_types.ALWAYS_ON, label: 'Always On' },
  { value: socket_types.JET_PUMP, label: 'Jet Pump' },
  { value: socket_types.IND_HEAT_PUMP, label: 'Ind. Heating Pump' },
  { value: socket_types.UV_SANITISER, label: 'UV Sanitiser' },

  // { value: 13, Label: "Pool/Spa"},
  // { value: 14, label: "Solar"},
  // { value: 15, label: "Water Feature"},
  // { value: 16, label: "Infloor"},
  // { value: 17, label: "Gas Heater"},
  // { value: 18, label: "Heat Pump"},

  // { value: 30, label: "Feature Solar"},
  // { value: 32, label: "Heating"
];

export const ResetOptionsSelect = [
  { value: 0, label: 'None' },
  { value: 0xf101, label: 'Restart' },
  { value: 0xf102, label: 'Erase Wifi Data' },
  { value: 0xf103, label: 'Reset Factory' },
];

export const ResetWifiSelect = [
  { value: 0, label: 'None' },
  { value: 0xf102, label: 'Erase Wifi Data' },
];

export const pumpModelOptionsSelect = [
  { value: 0, label: 'None' },
  { value: 6, label: 'DAB' },
  { value: 16, label: 'Davey VSD' },
  { value: 29, label: 'Emaux EcoFlow VSP' },
  { value: 27, label: 'Emaux E-Turbo VSP' },
  { value: 28, label: 'Emaux SuperPower VSP' },
  { value: 5, label: 'Insnrg Qi' },
  { value: 26, label: 'Insnrg LSV' },
  { value: 17, label: 'Insnrg Zi' },
  { value: 3, label: 'Hayward (485)' },
  { value: 15, label: 'Hayward MaxFlo VS / TriStar VS' },
  { value: 25, label: 'Henden 280 3 Speed' },
  { value: 9, label: 'Henden 3 Speed' },
  { value: 20, label: 'Henden VSD 400' },
  { value: 19, label: 'Legend Ultra VS 1.0 & 1.5hp' },
  { value: 23, label: 'Madimack Inverflow Eco' },
  { value: 24, label: 'Madimack Inverflow Pro/Ultra' },
  { value: 32, label: 'Madimack Inverflow Plus' },
  { value: 30, label: 'Neptune X-Eco' },
  { value: 31, label: 'Neptune X-Pro' },
  { value: 12, label: 'Oasis V Series' },
  { value: 4, label: 'Pentair (485)' },
  { value: 22, label: 'Pentair EM800' },
  { value: 13, label: 'Pentair EM1500' },
  { value: 8, label: 'Reltech' },
  { value: 2, label: 'Reltech (485)' },
  { value: 11, label: 'Reltech P (485)' },
  { value: 10, label: 'Speck' },
  { value: 7, label: 'Theraflo TVS 1.0 & 1.5hp V1' },
  { value: 1, label: 'Theralux TVS Pro 1.0 & 1.5hp V2' },
  { value: 14, label: 'Theralux TVS Pro 1.25 & 1.75hp V3' },
  { value: 18, label: 'Theralux TVS Pro II 1.0 & 1.5hp V4' },
  { value: 21, label: 'Waterco Hydrostorm Eco' },
];

export const expansionTypes = [
  { value: 0, label: 'Standard' },
  { value: 1, label: 'Heater Exp' },
  { value: 2, label: 'Smart Heater' },
  { value: 0xfe, label: 'Not Configured ' },
];

export const sheaterFunc = [
  { value: 0, label: 'Unconfigured' },
  { value: 1, label: 'Main Heater' },
  { value: 2, label: 'Secondary Heater' },
];

export const dosingOptions = [
  { value: 0, label: 'Idle' },
  { value: 1, label: 'Dosing Acid' },
  { value: 2, label: 'Dosing Chlorine' },
];

export const dosingOptionsEnabled = [
  { value: 0, label: 'No Dosing' },
  { value: 1, label: 'Acid Dosing Only' },
  { value: 2, label: 'Acid & Chlorine Dosing' },
];

export const sheaterTypes = [
  { value: 0, label: 'AUTO' },
  { value: 1, label: 'NONE' },
  { value: 2, label: 'THERALUX' },
  { value: 3, label: 'AQUARK' },
  { value: 4, label: 'OASIS' },
  { value: 5, label: 'RHEEM' },
  { value: 6, label: 'INVALID' },
];

export const lightBrandOptionsSelect = [
  { value: 0, label: 'Single Colour' },
  { value: 1, label: 'Astral' },
  { value: 2, label: 'AquaQuip' },
  { value: 3, label: 'Aquaquip InstaTouch' },
  { value: 4, label: 'Spa Electrics' },
  { value: 5, label: 'Aquatight' },
  { value: 6, label: 'Spa Electrics Multi-plus' },
  { value: 7, label: 'ModLite' },
  { value: 8, label: 'Jandy' },
  { value: 9, label: 'LED Pro' },
  { value: 10, label: 'Aquatight Supa' },
  // { value: 11, label: "WaterCo"},
  { value: 12, label: 'Pentair GloBrite' },
];

export const runOnceTimerOptions = [
  { value: 0, label: 'OFF' },
  { value: 1, label: '1 Min' },
  { value: 2, label: '2 Min' },
  { value: 3, label: '3 Min' },
  { value: 4, label: '4 Min' },
  { value: 5, label: '5 Min' },
  { value: 10, label: '10 Min' },
  { value: 15, label: '15 Min' },
  { value: 30, label: '30 Min' },
  { value: 45, label: '45 Min' },
  { value: 60, label: '1 Hour' },
  { value: 90, label: '1.5 Hours' },
  { value: 120, label: '2 Hours' },
  { value: 180, label: '3 Hours' },
  { value: 240, label: '4 Hours' },
  { value: 300, label: '5 Hours' },
  { value: 360, label: '6 Hours' },
  { value: 420, label: '7 Hours' },
  { value: 480, label: '8 Hours' },
  { value: 720, label: '12 Hours' },
];

export const pumpManualOnOff = [
  { value: 0, label: 'OFF' },
  { value: 1, label: 'ON - Backwash' },
  { value: 0x0101, label: 'Speed 1' },
  { value: 0x0201, label: 'Speed 2' },
  { value: 0x0301, label: 'Speed 3' },
  { value: 0x0401, label: 'Speed 4' },
  { value: 0xffff, label: 'Auto' },
];

export const waterFeatureType = [
  { value: 0, label: 'None' },
  { value: 1, label: 'Pump' },
  { value: 2, label: 'Valve' },
  { value: 3, label: 'Pump & Valve' },
];
